import React from 'react';

import { TableComponent } from 'commons/components/Table';
import { STOProcessedItem } from 'commons/types';

import { STOCheckSummaryPageStyle as S } from '../STOCheckSummaryPage.style';

import { summaryTableConfig } from './configs';

interface ISTOBinListProps {
  pickActual: STOProcessedItem[];
}

export const STOCheckBinList: React.FC<ISTOBinListProps> = ({ pickActual }) => {
  return (
    <S.ItemContentWrapper container>
      <TableComponent
        data={pickActual || []}
        config={summaryTableConfig}
        additionalTableConfig={{ bodyFontSize: '12px' }}
      />
    </S.ItemContentWrapper>
  );
};
